// src/components/Settings/SMSSettings.jsx
import React from 'react';

export default function SMSSettings({ settings, onUpdate, loading }) {
  return (
    <div>
      <h3 className="text-lg font-semibold mb-4">SMS Settings</h3>
      <div className="space-y-4">
        <div className="bg-blue-50 p-4 rounded-lg">
          <p className="text-sm text-blue-800">
            SMS integration is configured via Africa's Talking API.
            Current balance and settings can be managed in the SMS Composer section.
          </p>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Sender ID
          </label>
          <input
            type="text"
            className="input-field w-64"
            placeholder="BROMINON"
            disabled
          />
        </div>
      </div>
    </div>
  );
}